import ReactGA from 'react-ga';

function mergeNewValidation(formName, inputState, prevState) {
  if (formName === 'MultiHouse' && !!inputState.hasError) {
    ReactGA.event({
      category: 'Validation',
      action: `error shown ${inputState.name}`,
      label: (inputState.bundleHasError.length > 1 && !inputState.bundleHasError[1]) ? 'data format' : 'required'
    });
  }

  const newState = JSON.parse(JSON.stringify(prevState));
  if (newState[formName] == null) {
    newState[formName] = {
      formHasError: false,
      validations: []
    };
  }
  newState[formName].validations.forEach((elem, i) => {
    if (elem.inputName === inputState.name) {
      newState[formName].validations.splice(i, 1);
    }
  });
  newState[formName]
    .validations.push({ inputName: inputState.name, hasError: inputState.hasError, value: inputState.value ? inputState.value : null, id: inputState.id ? inputState.id : null });
  const errorValidation = newState[formName].validations.find(x => x.hasError === true);
  newState[formName].formHasError = (errorValidation) ? errorValidation.hasError : false;
  return newState;
}

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case 'VALIDATE_INPUT':
      return mergeNewValidation(action.data.formName, action.data.inputState, state);
    default:
      return state;
  }
}

export function updateValidationState(dispatch, state, formName) {
  dispatch({
    type: 'VALIDATE_INPUT',
    data: {
      formName,
      inputState: state
    }
  });
}
